import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import '@esi/leaf-web/lib/wc/components/progress-steps-item/progress-steps-item';
import { LeafAngularWrapper } from '../leaf-angular-wrapper';

@Component({
  selector: 'cigna-leaf-progress-steps-item',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-progress-steps-item
      [message]="message"
      [name]="name"
      [status]="status"
      [svg]="svg"
      [layout]="layout"
      [step-number]="stepNumber"
      [total-steps]="totalSteps"
    >
      <ng-content></ng-content>
    </leaf-progress-steps-item>
  `,
})
export class CignaLeafProgressStepsItemComponent extends LeafAngularWrapper {
  // todo: replace with import types once this bug is fixed https://github.com/cigna-group/leaf-web/issues/323
  @Input() message?: string;
  @Input() name: string;
  @Input() status?: 'complete' | 'current' | 'error' | 'incomplete' | 'warning';
  @Input() svg: string;
  @Input() layout: 'horizontal' | 'vertical';
  @Input() stepNumber: number;
  @Input() totalSteps: number;
}
